
import axios from 'axios';
import * as Constants from "../Common/constants";
export default {
    user : {
        login: (payload) =>
            axios.post(Constants.SERVER+'/login', {email:payload.email, pwd:payload.pwd}).then(res=>res.data).catch(error => { throw new Error(error); console.dir(error)} ),
      
    }
}



// WEBPACK FOOTER //
// ./src/Api/user.js